import { useMemo } from "react";

import { useGetOrders } from "@/api";
import { GetOrdersOrder } from "@/api/schemas/getOrdersOrder";
import { GetOrdersSortBy } from "@/api/schemas/getOrdersSortBy";
import {
  buildWeeklyOrderTrend,
  computeWeekOverWeekGrowth,
} from "@/lib/dashboard/buildOrderTrend";
import { parseOrderListResponse } from "@/lib/validation/dashboard.schemas";
import { useSessionStore } from "@/stores/session.store";

export function useOrderTrend() {
  const activeStoreId = useSessionStore((state) => state.activeStoreId);

  const params = useMemo(
    () =>
      activeStoreId !== null
        ? {
            store_id: activeStoreId,
            per_page: 100,
            page: 1,
            sort_by: GetOrdersSortBy.createdAt,
            order: GetOrdersOrder.DESC,
          }
        : undefined,
    [activeStoreId],
  );

  const { data: orders, isLoading } = useGetOrders(params, {
    query: {
      enabled: activeStoreId !== null,
      select: (response) => parseOrderListResponse(response.data)?.data ?? [],
    },
  });

  const data = useMemo(() => buildWeeklyOrderTrend(orders ?? []), [orders]);
  const growthPercent = useMemo(
    () => computeWeekOverWeekGrowth(orders ?? []),
    [orders],
  );

  return {
    data,
    growthPercent,
    isLoading,
  };
}
